import React from 'react'
import '../../styles/footer.css'
import { FaHeart, FaWhatsapp } from "react-icons/fa";
import { useSelector } from 'react-redux';
const Footer = () => {
  const { isDark } = useSelector((state) => state.useReducer);
  return (
    <div className='footer' style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}` }}>
      <p style={{ color: `${isDark ? "#fff" : "#000"}` }}><FaHeart style={{ color: "#3F51B5", marginLeft: "10px" }} /> Munesh Kumar<FaHeart style={{ color: "#3F51B5", marginLeft: "10px" }} /></p>
      <a href="https://wa.me/+923463037523" target='_blank' rel="noreferrer" style={{ backgroundColor: "#3F51B5" }}>
        <FaWhatsapp id='whatsapp-icon'/>
      </a>
    </div>
  )
}

export default Footer
